
  var advance = function advance() {
    if(typeof quickAddButton == 'function'){
      quickAddButton();
    }

    window.GroupSwatches && window.GroupSwatches.init();

    if (window.innerWidth > 1024) {
    document.querySelectorAll('.grid-bottom .main-color-variant .color-var.click').forEach(function(element) {
      element.addEventListener('click', function(event) {
        event.preventDefault();
        var attVal = this.getAttribute('data-id');
        var productItem = this.closest('.product-item');
        var innerGrids = productItem.querySelectorAll('.snippet-product-grid .inner-product-grid');
        innerGrids.forEach(function(innerGrid) {
          if (attVal === innerGrid.getAttribute('data-id')) {
            innerGrids.forEach(function(g) {
              g.classList.remove('active');
            });
            innerGrid.classList.add('active');
          }
        });
      });
    });
    }

  }
  // var infinitescroll = {
  //   scolljs: function(){
  //     var endlessScroll = new Ajaxinate({
  //       container: '#product-grid',
  //       pagination: '#AjaxinatePagination',
  //       // loadingText: document.getElementById('AjaxinatePagination').dataset.text,
  //       callback: advance,
  //       //offset: 200
  //     });
  //   }
  // }
  // infinitescroll.scolljs();
  // Scroll restoration handled by browser bfcache — no manual tracking needed

// product grid view
if (window.innerWidth < 1025) {
  document.querySelectorAll('.coll-view span').forEach(span => {
    span.addEventListener('click', () => {
      const viewClass = span.getAttribute('data-view');
      span.classList.add('active');
      const siblings = span.closest('li').parentElement.querySelectorAll('li span');
      siblings.forEach(sib => {
        if (sib !== span) sib.classList.remove('active');
      });
      const grid = document.querySelector('.collection-grid');
      grid.classList.remove('view-1', 'view-2');
      grid.classList.add(viewClass);
    });
  });
}
// product grid view

// colour-var click handled by GroupSwatches event delegation
window.GroupSwatches && window.GroupSwatches.init();


/*
// wishlist click
document.querySelectorAll('.wishlist-btn').forEach(btn => {
  btn.addEventListener('click', () => {
    console.log('234234');
    btn.closest('.snippet-product-grid').classList.add('open-wishlist');
    btn.textContent = 'Select Size for Wishlist';
  });
});
document.querySelectorAll('.snippet-product-grid').forEach(function(grid) {
  grid.addEventListener('mouseleave', function() {
    if (grid.classList.contains('open-wishlist')) {
      grid.classList.remove('open-wishlist');
      const buttons = grid.querySelectorAll('.wishlist-btn');
      buttons.forEach(function(btn) {
        btn.textContent = 'Add to wishlist';
      });
    }
  });
});
*/



